<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>{{ pageData.MenuName }}-查詢條件</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td width="10%">查調類別</td>
                  <td width="29%">
                    <select v-model="form.type">
                      <option value="1">申報人授權</option>
                    </select>
                  </td>
                  <td width="8%">年度</td>
                  <td width="53%">
                    <select v-model="form.syear">
                      <option
                        v-for="(data, index) in dropDownList.syears"
                        :key="index"
                        :value="data.sYear"
                      >
                        {{ data.sYear }}
                      </option>
                    </select>
                    <span v-show="form.type == '1'" style="margin-left: 10px"
                      >查調日期:</span
                    ><span v-show="form.type == '1'">{{
                      form.authOpenDate
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td>歸戶財產項目</td>
                  <td colspan="3">
                    <p>
                      <label
                        v-for="(data, index) in dropDownList.properties"
                        :key="index"
                      >
                        <input
                          type="checkbox"
                          v-model="form.properties"
                          :value="data.mcode"
                        />
                        {{ data.mvalue }}</label
                      >
                    </p>
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <label for="checkbox"
                      ><span>
                        <input
                          type="submit"
                          class="btn"
                          @click="btnQuery()"
                          value="查詢" />
                        <input
                          type="submit"
                          class="btn"
                          @click="btnExec()"
                          :disabled="form.properties.length === 0"
                          value="執行" /></span
                    ></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <table width="100%" v-if="grid.gridDatas">
            <tbody>
              <tr>
                <td align="right">
                  <input
                    type="button"
                    value="<<"
                    class="btn"
                    style="height: 28px"
                    @click="form.currentpage = grid.paginaiton.pageNo - 1"
                    v-show="grid.paginaiton.pageNo > 1"
                  />
                  <span
                    v-for="(data, index) in grid.paginaiton.pages"
                    :key="index"
                    style="cursor: pointer"
                    :style="
                      grid.paginaiton.pageNo == data
                        ? 'color:red'
                        : 'color:black'
                    "
                    @click="form.currentpage = parseInt(data)"
                  >
                    {{
                      grid.paginaiton.pageNo == data ? "[" + data + "]" : data
                    }}
                  </span>
                  <input
                    type="button"
                    class="btn"
                    value=">>"
                    style="height: 28px"
                    v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                    @click="form.currentpage = grid.paginaiton.pageNo + 1"
                  />
                  ［每頁<input
                    type="text"
                    v-model.number.lazy="form.pagesize"
                    size="2"
                    maxlength="4"
                  />

                  <input type="button" class="btn" value="筆" />，第<input
                    type="text"
                    v-model.number.lazy="form.currentpage"
                    size="2"
                    maxlength="4"
                  />
                  <input type="button" class="btn" value="頁" />，共
                  {{ grid.paginaiton.totalPage }} 頁
                  {{ grid.paginaiton.totalCount }} 筆］
                </td>
              </tr>
            </tbody>
          </table>
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th>記錄</th>
                    <th>查調類別</th>
                    <th>年度</th>
                    <th>開始執行時間</th>
                    <th>結束執行時間</th>
                    <th>狀態</th>
                    <th>執行人員</th>
                  </tr>
                </thead>
                <tbody v-if="grid.gridDatas && grid.gridDatas.length > 0">
                  <tr v-for="(data, index) in grid.gridDatas" :key="index">
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        value="查"
                        data-toggle="modal"
                        data-target=".bs-example-modal-lg"
                        @click="btnDetail(data)"
                      />
                    </td>
                    <td>{{ data.type }}</td>
                    <td>{{ data.syear }}</td>
                    <td>{{ data.execsdtime }}</td>
                    <td>{{ data.execedtime }}</td>
                    <td>{{ data.status }}</td>
                    <td>{{ data.updateuserid }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="6" style="text-align: center">查無資料</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 查詢結果結束-->
        </div>
      </div>
    </div>
    <PdisFooter />

    <Modal
      v-model="Modal.show"
      :title="Modal.title"
      :modalStyle="{ 'max-width': '1200px' }"
      :ServiceUnit="Modal.ServiceUnit"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>&nbsp;</td>
                <td>
                  <textarea
                    cols="120"
                    rows="10"
                    v-model="Modal.PreData.message"
                  ></textarea>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </Modal>

    <Alert
      v-model="Alert.show"
      :title="Alert.title"
      :ServiceUnit="pageData.ServiceUnit"
    >
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import { getMenu,logOut } from "@/config/util.js";
import {
  M_GetAuthOpenTime,
  GetCodeMain,
  S703_SearchGrid,
  ThreadingAircraft,
  ThreadingBuilding,
  ThreadingDebt,
  ThreadingDeposit,
  ThreadingFiabow,
  ThreadingInsurance,
  ThreadingLand,
  ThreadingMarginTrading,
  ThreadingMarketableSecurities,
  ThreadingInvestment,
  ThreadingOtherProperties,
  ThreadingVehicle,
  ThreadingVessel,
  ThreadingTrustLand,
  ThreadingTrustBuilding,
  ThreadingTrustStock,
  ThreadingExchangeStock
} from "@/service/api.js";
export default {
  name: "S703",
  data: function () {
    return {
      pageData: {
        MenuIndex: 3,
        MenuName: "S703查調財產歸戶作業",
        PrgName: "S703",
        ServiceUnit: "CY",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      form: {
        syear: "",
        type: "1",
        properties: [],
        authOpenDate: "",
        currentpage: 1,
        pagesize: 10,
      },
      dropDownList: {
        properties: [],
      },
      grid: {},
      Modal: {
        show: false,
        title: "",
        PreData: {},
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    Modal: VueModal,
    Alert: VueModal,
  },
  methods: {
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    getAuthOpenTimeList: function () {
      const self = this;
      M_GetAuthOpenTime().then((rData) => {
        self.dropDownList.syears = rData.returnObject;
        self.form.syear = String(new Date().getFullYear() - 1911 - 1);
      });
    },
    //第一頁
    btnQuery: function () {
      const self = this;
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        PRGCODE: self.form.properties,
        TYPE: self.form.type,
        SYEAR: self.form.syear,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S703_SearchGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
          self.grid.gridDatas.forEach((x) => {
            x.execsdtime = self
              .$moment(x.execsdtime)
              .format("YYYYMMDD HH:mm:ss");
            x.execedtime = self
            .$moment(x.execedtime)
            .format("YYYYMMDD HH:mm:ss");
          });
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    //查
    btnDetail: function (data) {
      const self = this;
      self.Modal.title = "S703系統排程執行記錄查詢-執行記錄";
      self.Modal.PreData = data;
      self.Modal.show = true;
    },
    btnExec: function () {
      var self = this;
      if (self.form.properties.length > 1) {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = [
          "為避免造成系統繁忙，排程執行一次只能選擇一個財產項目!!",
        ];
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
      }

      var serviceUnit = [];
      serviceUnit.push(self.pageData.ServiceUnit);
      let postData = {
        serviceUnit: serviceUnit,
        pdisType: self.form.type,
        syear: self.form.syear,
        id: self.loginInfo.id,
      };

      switch (self.form.properties[0]) {
        case "ThreadingAircraft":
          ThreadingAircraft(postData).then((rData) => {
            if (rData.result) {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔成功"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
                self.btnQuery();
              };
            } else {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔失敗"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
              };
            }
          });
          break;

        case "ThreadingBuilding":
          ThreadingBuilding(postData).then((rData) => {
            if (rData.result) {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔成功"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
                self.btnQuery();
              };
            } else {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔失敗"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
              };
            }
          });
          break;

        case "ThreadingDebt":
          ThreadingDebt(postData).then((rData) => {
            if (rData.result) {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔成功"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
                self.btnQuery();
              };
            } else {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔失敗"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
              };
            }
          });
          break;

        case "ThreadingDeposit":
          ThreadingDeposit(postData).then((rData) => {
            if (rData.result) {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔成功"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
                self.btnQuery();
              };
            } else {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔失敗"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
              };
            }
          });
          break;

        case "ThreadingFiabow":
          ThreadingFiabow(postData).then((rData) => {
            if (rData.result) {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔成功"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
                self.btnQuery();
              };
            } else {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔失敗"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
              };
            }
          });
          break;

        case "ThreadingInsurance":
          ThreadingInsurance(postData).then((rData) => {
            if (rData.result) {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔成功"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
                self.btnQuery();
              };
            } else {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔失敗"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
              };
            }
          });
          break;

        case "ThreadingLand":
          ThreadingLand(postData).then((rData) => {
            if (rData.result) {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔成功"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
                self.btnQuery();
              };
            } else {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔失敗"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
              };
            }
          });
          break;

        case "ThreadingMarginTrading":
          ThreadingMarginTrading(postData).then((rData) => {
            if (rData.result) {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔成功"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
                self.btnQuery();
              };
            } else {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔失敗"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
              };
            }
          });
          break;

        case "ThreadingMarketableSecurities":
          ThreadingMarketableSecurities(postData).then((rData) => {
            if (rData.result) {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔成功"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
                self.btnQuery();
              };
            } else {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔失敗"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
              };
            }
          });
          break;

        case "ThreadingInvestment":
          ThreadingInvestment(postData).then((rData) => {
            if (rData.result) {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔成功"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
                self.btnQuery();
              };
            } else {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔失敗"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
              };
            }
          });
          break;

        case "ThreadingOtherProperties":
          ThreadingOtherProperties(postData).then((rData) => {
            if (rData.result) {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔成功"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
                self.btnQuery();
              };
            } else {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔失敗"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
              };
            }
          });
          break;

        case "ThreadingVehicle":
          ThreadingVehicle(postData).then((rData) => {
            if (rData.result) {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔成功"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
                self.btnQuery();
              };
            } else {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔失敗"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
              };
            }
          });
          break;

        case "ThreadingVessel":
          ThreadingVessel(postData).then((rData) => {
            if (rData.result) {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔成功"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
                self.btnQuery();
              };
            } else {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔失敗"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
              };
            }
          });
          break;

        case "ThreadingTrustLand":
          ThreadingTrustLand(postData).then((rData) => {
            if (rData.result) {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔成功"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
                self.btnQuery();
              };
            } else {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔失敗"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
              };
            }
          });
          break;

        case "ThreadingTrustBuilding":
          ThreadingTrustBuilding(postData).then((rData) => {
            if (rData.result) {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔成功"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
                self.btnQuery();
              };
            } else {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔失敗"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
              };
            }
          });
          break;

        case "ThreadingTrustStock":
          ThreadingTrustStock(postData).then((rData) => {
            if (rData.result) {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔成功"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
                self.btnQuery();
              };
            } else {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔失敗"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
              };
            }
          });
          break;

        case "ThreadingExchangeStock":
          ThreadingExchangeStock(postData).then((rData) => {
            if (rData.result) {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔成功"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
                self.btnQuery();
              };
            } else {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["轉檔失敗"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
              };
            }
          });
          break;
      }
    },
    btnShowLogModal: function (data) {
      const self = this;
      self.Modal.show = true;
      self.Modal.title = "S703系統排程執行記錄查詢-執行記錄";
      self.Modal.PreData = data;
    },
  },
  watch: {
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.btnQuery();
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.btnQuery();
      }
    },
    "form.syear": function () {
      const self = this;
      self.form.authOpenDate = self.dropDownList.syears.filter(
        (x) => x.sYear === self.form.syear
      )[0].authOpenDate;
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    self.getAuthOpenTimeList();
    let postData = {
      codeId: "S703",
    };
    GetCodeMain(postData).then((rData) => {
      self.dropDownList.properties = rData.returnObject;
      //self.dropDownList.properties = rData.returnObject.filter(x=>x.diptCode != 'CY');
    });
    const Menu = getMenu(self.pageData.PrgName);
    if (Menu) {
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
  },
};
</script>

<style scoped src="@/assets/css/Cy.css" />
